export default __webpack_public_path__ + "static/media/chocolate.576e2df6.jpg";